import { z } from 'zod';
import {
  DataMessageTypeEnum,
  type ModelOutputRetractedMessage,
} from './messages.types';

export const MODEL_ATTEMPT_KEY_METADATA_FIELD = 'langgraph_checkpoint_ns';
export const DEFAULT_MODEL_ATTEMPT_KEY = 'root';

export const resolveModelAttemptKey = (
  checkpointNamespace?: string,
): string => {
  const trimmed = checkpointNamespace?.trim();

  return trimmed && trimmed.length > 0 ? trimmed : DEFAULT_MODEL_ATTEMPT_KEY;
};

const ModelOutputRetractedMessageSchema = z.object({
  id: z.string().optional(),
  type: z.literal(DataMessageTypeEnum.ModelOutputRetracted),
  modelAttemptKey: z.string().min(1),
  reason: z.enum(['retry', 'max_tokens_reduced', 'model_fallback']),
  attempt: z.number().int().nonnegative(),
});

const ProviderMetadataSchema = z.object({
  metadata: z.object({
    [MODEL_ATTEMPT_KEY_METADATA_FIELD]: z.string(),
  }),
});

export const parseModelOutputRetractedMessage = (
  value: unknown,
): ModelOutputRetractedMessage | undefined => {
  const parsed = ModelOutputRetractedMessageSchema.safeParse(value);

  return parsed.success ? parsed.data : undefined;
};

export const readModelAttemptKey = (
  providerMetadata: unknown,
): string | undefined => {
  const parsed = ProviderMetadataSchema.safeParse(providerMetadata);

  return parsed.success
    ? resolveModelAttemptKey(
        parsed.data.metadata[MODEL_ATTEMPT_KEY_METADATA_FIELD],
      )
    : undefined;
};
